// extracted by mini-css-extract-plugin
export var orderSummary = "_q6-0";
export var showMoreLessButton = "_q6-1";